import { useMemo } from 'react';

import { useLocation } from 'react-router-dom';

import { matchDboBreadcrumbs } from 'pages/db-optimization/v2/DbOptimizationControllerV2/utils';

import {
  normalizeBreadcrumbItem,
  resolveOneClickPageLabel,
  type NormalizedBreadcrumbItem,
} from '@oneclick/routing';

export const useNavCurrentPageLabel = ():
  | NormalizedBreadcrumbItem[]
  | undefined => {
  const location = useLocation();

  return useMemo(() => {
    const dboCrumbs = matchDboBreadcrumbs(location.pathname);
    if (dboCrumbs?.length) {
      return dboCrumbs.map(normalizeBreadcrumbItem);
    }

    return resolveOneClickPageLabel(location.pathname, location.search);
  }, [location.pathname, location.search]);
};
